var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar'),_c('v-row',{staticClass:"d-flex justify-center pt-5"},[_c('v-col',{attrs:{"cols":"6"}},[_c('ItemCard',{attrs:{"item":_vm.item}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }